module.exports = __webpack_public_path__ + "static/media/instagram.fa07de6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/instagram.svg
// module id = 883
// module chunks = 0